var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m6.18 16.395 9.808-9.807 2.12 2.12L8.3 18.519 5 19.639zm10.5-10.392.707-.71a1 1 0 0 1 1.413 0l.707.71a1 1 0 0 1 0 1.414l-.707.707-2.12-2.12z"
  })));
};
export { SvgEdit as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNNi4xOCAxNi4zOTVsOS44MDgtOS44MDcgMi4xMiAyLjEyTDguMyAxOC41MTkgNSAxOS42MzlsMS4xOC0zLjI0NHptMTAuNS0xMC4zOTJsLjcwNy0uNzFhMS4wMDEgMS4wMDEgMCAwMTEuNDEzIDBsLjcwNy43MWExIDEgMCAwMTAgMS40MTRsLS43MDcuNzA3LTIuMTItMi4xMnoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";